import {yascCreateEntityApiRoutesV3, YascRestEntityApiAdapterV3} from '@yasc/yasc-material-components';
import {
    EmailClientConnectionRes,
    EmailClientReq,
    EmailClientRes
} from '../../../../../contracts/v0/administration/email.contracts';
import {Observable} from "rxjs";
import {ApiV0AdminIntegrations} from './api.v0.admin.integrations';
import {RestApiService} from '../../../../rest-api.service';

export class ApiV0AdminIntegrationsEmailClientsV3 extends YascRestEntityApiAdapterV3<EmailClientRes, EmailClientRes, EmailClientReq, EmailClientReq, number> {


    constructor(
        v0: ApiV0AdminIntegrations,
        rest: RestApiService,
    ) {
        super({
            idKey: 'id' as const,
            modelTypes: {
                row: EmailClientRes,
                detail: EmailClientRes,
                create: EmailClientReq,
                patch: EmailClientReq,
            },
            routes: yascCreateEntityApiRoutesV3(v0.segment + '/EmailClient'),
            rest
        })
    }


    testConnection(item: EmailClientReq): Observable<EmailClientConnectionRes> {
        return this.rest.post<EmailClientReq, EmailClientConnectionRes>(`${this.routes.base}/test`, EmailClientRes, item);
    }
}